import { PRIMARY } from '@/constants/color';
import { FileDownloadOutlined, FileUploadOutlined } from '@mui/icons-material';
import { ChangeEvent, memo, useRef } from 'react';
import { toast } from 'react-toastify';
import StepByStepTooltip from './StepByStepTooltip';

interface GeoAddressRadiusUploadProps {
  onUpload: (file: File) => void;
}

const GeoAddressRadiusUpload = memo(({ onUpload }: GeoAddressRadiusUploadProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    if (!file) {
      toast.error(`Failed to upload file\nPlease try again`);
    }
    if (!file.name.endsWith('.csv')) {
      toast.error('Please upload a CSV file');
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      return;
    }

    onUpload(file);

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div className='flex flex-col border rounded-md w-[100%] px-5 py-2 gap-2 print:hidden'>
      <div className='flex justify-between'>
        <span className={`text-[${PRIMARY}] text-[14px] font-semibold`}>Bulk Upload of Address Radius File</span>
        <StepByStepTooltip />
      </div>

      <div className='flex items-center gap-3'>
        <label>
          <a href='./template.csv' download='template.csv'>
            <span className='flex items-center justify-center cursor-pointer gap-2 w-[120px] h-[36px] rounded bg-[#1b433226] hover:bg-[#1b43328d]'>
              <FileDownloadOutlined />
              Template
            </span>
          </a>
        </label>
        <label>
          <input ref={fileInputRef} hidden type='file' accept='.csv' onChange={handleUpload} />
          <span className='flex items-center justify-center cursor-pointer gap-2 w-[150px] h-[36px] rounded bg-[#1b433226] hover:bg-[#1b43328d]'>
            <FileUploadOutlined />
            Upload CSV
          </span>
        </label>
      </div>
    </div>
  );
});

export default GeoAddressRadiusUpload;
